<template>
<section class="why_choose_us section-padding gray-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h3>
                    {{ servicio.servicio_titulo }}
                </h3>
                <div v-html="servicio.servicio_description"></div>
            </div>
            <div class="col-md-6">
                <div class="services_image">
                    <img 
                    :src="servicio.servicio_imagen" alt="image" />
                    <div class="service_heading white-text">
                        <h3>{{ servicio.texto_imagen }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
    props: {
        servicio: Object,
    },
};
</script>

<style lang="scss" scoped>

</style>
